﻿import React from 'react'
import IconHelper from '@bazooka_se/lf-icons'

// custom header for displaying on My Pages / My Possessions

const PossessionCustomHeading = ({ value, text, isCurrent, date, heading }) => {
    const dateToRender = date.slice(0, 10)
    return (
        <React.Fragment>
            <h2 className={`possessions-custom-header__heading`}>{ heading }</h2>
            <div className="possessions-custom-header__content">
                <p className="possessions-custom-header__content__value">{text}: <span>{value} kr</span></p>
                <p className={`possessions-custom-header__content__status`}>Status:
                    <span className={`possessions-custom-header__content__icon`} dangerouslySetInnerHTML={{ __html: IconHelper(isCurrent ? 'check-circle' : 'clock').outerHTML }}></span>
                    <span className="possessions-custom-header__content__toggle" role="button" dangerouslySetInnerHTML={{__html: IconHelper('chev-down').outerHTML }}></span></p>
            </div>
            {!isCurrent ? <div><p className="possessions-custom-header__date">Börjar gälla: <span>{dateToRender}</span></p></div> : null}
        </React.Fragment>
    )
}

export default PossessionCustomHeading
